<template>
  <div id="qualityTask" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <!-- <el-select
          class="m-r-10"
          v-model="search.dataSource"
          @change="searchData"
          placeholder="请选择"
          clearable
          filterable
          size="small"
        >
          <el-option
            v-for="(item, index) in dataSourceList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-input
          class="w-200px mr-10px"
          v-model="search.keyword"
          @keyup.enter.native="searchData"
          @clear="searchData"
          size="small"
          :placeholder="$t('任务名称')"
          clearable
        ></el-input>
        <el-select
          class="w-200px mr-10px"
          v-model="search.runStatus"
          @change="searchData"
          :placeholder="$t('运行状态')"
          clearable
          filterable
          size="small"
        >
          <el-option
            v-for="(item, index) in runStatusList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="search.startDate"
          type="datetime"
          :placeholder="$t('开始日期')"
          size="small"
          class="w-200px mr-10px"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-date-picker
          v-model="search.endDate"
          type="datetime"
          :placeholder="$t('结束日期')"
          size="small"
          class="w-200px mr-10px"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-input
          class="w-200px mr-10px"
          v-model="search.name"
          @keyup.enter.native="searchData"
          @clear="searchData"
          size="small"
          :placeholder="$t('创建人姓名')"
          clearable
        ></el-input>
        <el-button type="primary" @click="searchData">{{ $t('search') }}</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="openDialog('add')">{{
          $t('create')
        }}</el-button>
        <el-button @click="openDialog('read')" :disabled="!$hasAccess('read')">{{
          $t('view')
        }}</el-button>
        <el-button :disabled="!$hasAccess('update')" @click="openDialog('edit')">{{
          $t('edit')
        }}</el-button>
        <el-button :disabled="!$hasAccess('delete')" type="danger" @click="remove">{{
          $t('delete')
        }}</el-button>
      </el-row>
      <el-row class="mt-20px" style="height: calc(100% - 106px)">
        <el-table
          v-loading="loading.table"
          ref="singleTable"
          height="100%"
          :data="tableData"
          class="w-full"
          @row-click="rowClick"
          highlight-current-row
          border
          stripe
        >
          <el-table-column
            type="index"
            width="55"
            :label="$t('序号')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            :label="$t('任务名称')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="runStatus" :label="$t('运行状态')" show-overflow-tooltip>
            <template slot-scope="scope">{{
              _.get(_.find(runStatusList, { id: scope.row.runStatus }), 'name')
            }}</template>
          </el-table-column>
          <el-table-column
            prop="executionFrequency"
            :label="$t('执行频次')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="lastRunTime"
            :label="$t('上次运行时间')"
            width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="lastRunStatus" :label="$t('上次运行状态')" show-overflow-tooltip>
            <template slot-scope="scope">{{
              _.get(_.find(runStatusList, { id: scope.row.lastRunStatus }), 'name')
            }}</template>
          </el-table-column>
          <el-table-column
            prop="lastRunTakeTime"
            :label="$t('上次运行耗时秒')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="nextRunTime"
            :label="$t('下次运行时间')"
            width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="totalRunCount"
            :label="$t('总运行次数')"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="errorRunCount"
            :label="$t('失败次数')"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createdUserName"
            :label="$t('任务创建人')"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="lastModifiedUserName"
            :label="$t('最近修改人')"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="lastModifiedTime"
            :label="$t('修改时间')"
            width="160"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.lastModifiedTime
                  ? dayjs(scope.row.lastModifiedTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="mt-20px">
        <el-pagination
          class="float-right"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNo"
          :page-sizes="$pageSizeAll"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </el-row>
    </el-card>

    <!--详情-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      v-dialogDrag
    >
      <qualityTaskForm
        ref="qualityTaskForm"
        v-if="dialogVisible"
        :type="dialogType"
        :detailInfo="detailInfo"
        @closeDialog="closeDialog"
        @closeAndReset="closeAndReset"
      ></qualityTaskForm>
    </el-dialog>
  </div>
</template>

<script>
import DataSourceService from '@/services/DataSourceService'
import QualityTaskService from '@/services/QualityTaskService'
import qualityTaskForm from './components/qualityTaskForm'

export default {
  name: 'qualityTask',
  mixins: [],
  components: {
    qualityTaskForm,
  },
  data() {
    return {
      search: {
        keyword: '', // 任务名称
        dataSource: '', // 数据源
        runStatus: '', // 运行状态
        startDate: '', // 开始日期
        endDate: '', // 结束日期
        name: '', // 创建人姓名
      },
      loading: {
        table: false,
      },
      dataSourceList: [],
      currentRow: null,
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      runStatusList: [
        { id: 0, name: '执行成功' },
        { id: 1, name: '执行失败' },
        { id: 3, name: '待执行' },
        { id: 4, name: '已暂停' },
        { id: 5, name: '执行中' },
      ],

      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      detailInfo: {},
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 删除
    remove() {
      if (!this.currentRow) {
        this.$message.warning('请选择需要删除的数据')
        return
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 校验是否有运行数据(true有运行数据)
          const res = await QualityTaskService.checkHasRunData([this.currentRow.id])
          if (res) {
            this.$confirm('此任务产生的所有数据将删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(async () => {
              await this.del([this.currentRow.id])
            })
          } else {
            this.del([this.currentRow.id])
          }
        })
        .catch(() => {})
    },
    async del(id) {
      const res = await QualityTaskService.remove(id)
      if (res && res.code === 0) {
        this.$message.success('删除成功')
        this.getList()
      }
    },
    closeDialog() {
      if (this.$refs.qualityTaskForm.isChange) {
        this.$confirm('您尚有未保存的数据，是否取消?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
        })
          .then(() => {
            this.closeAndReset()
          })
          .catch(() => {})
      } else {
        this.closeAndReset()
      }
    },
    closeAndReset() {
      this.dialogVisible = false
      this.getList()
    },
    openDialog(type) {
      if (type !== 'add' && !this.currentRow) {
        this.$message.warning(`请选择需要${type === 'read' ? '查看' : '编辑'}的数据`)
        return
      }
      this.dialogType = type
      if (type === 'read') {
        this.$router.push(`./quality-task-form?id=${this.currentRow.id}`)
        return
      }
      this.dialogVisible = true
      this.dialogTitle = type === 'add' ? '创建任务' : '编辑任务'
      if (this.currentRow) {
        this.detailInfo = this.currentRow
      }
    },
    rowClick(row) {
      this.currentRow = row
    },
    // 查询质检源下拉
    async getDataSource() {
      const res = await DataSourceService.list({
        pageno: 1,
        pagesize: 999,
      })
      if (res && res.code === 0) {
        this.dataSourceList = res.data
      }
    },
    searchData() {
      this.pageNo = 1
      this.getList()
    },
    handleSizeChange() {
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    async getList() {
      this.loading.table = true
      const res = await QualityTaskService.getList({
        pageno: this.pageNo,
        pageSize: this.pageSize,
        keyword: this.search.keyword,
        // data_source_id: this.search.dataSource,
        run_status: this.search.runStatus,
        'last_run_time[$gte]': this.search.startDate,
        'last_run_time[$lte]': this.search.endDate,
        created_name: this.search.name,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.total = res.page ? res.page.recordCount : 0
        if (this.currentRow) {
          this.$nextTick(() => {
            const current = _.find(res.data, { id: this.currentRow.id })
            this.$refs.singleTable.setCurrentRow(current, true)
          })
        }
      }
      this.loading.table = false
    },
  },
  async created() {
    this.getDataSource()
    this.getList()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
}
</script>
<style lang="scss" scoped>

</style>
